<template>
    <div id="app" :class="{'fullScreen':$route.meta.fullScreen}">
      <commonHeadVue  v-if="!$route.meta.fullScreen"></commonHeadVue>
      <div class="container f-row">
        <navMenu v-if="!$route.meta.fullScreen"></navMenu>
        <div class="route_view" :class="{'h2':$route.name=='Login'}">
          <router-view ></router-view>
        </div>
        
      </div>
      <!-- <commonFootVue  v-if="$route.name!='Login'"></commonFootVue> -->
    </div>
</template>

<script>
import commonHeadVue from './components/commonHead.vue'
import commonFootVue from './components/commonFoot.vue'
import navMenu from './components/navMenu.vue'
export default {
  name: 'App',
  components:{
    commonHeadVue,
    commonFootVue,
    navMenu
  }
}
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 1200px;
  .container{
    // min-height: 700px;
    align-items: flex-start;
    .route_view{
      height: calc(100vh - 50px);
      overflow-y: scroll;
      flex: 1;
      &.h2{
        height: 100vh;
      }
    }
  }
}
.fullScreen{
  min-width: 375px !important;
  .route_view{
    height: 100vh !important;
  }
}
</style>
